import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getParkingSpaceList } from "../../usecases/ParkingUsecases"
import { set } from "react-hook-form";

export const fetchAllParkingSpots = createAsyncThunk(
  "parking/fetchAllParkingSpots",
  async (param, thunkAPI) => {
    try {
      let res = await getParkingSpaceList(param);
      return res;
    } catch (err) {
      console.log(err);
      return thunkAPI.rejectWithValue("Error");
    }
  }
);

export const fetchAllParkingSpotTypes = createAsyncThunk(
  "parking/fetchAllParkingSpotTypes",
  async () => {
  }
);

export const fetchParkingLot = createAsyncThunk(
  "parking/fetchParkingLot",
  async () => {
  }
);


const initialState = {
  parkingName: "",
  parkingSpaceView: "grid",
  parkingLot: null,
  selectedSpots: [],
  parkingSpots: [],
  selectedSpot: null,
  spotTypes: [],
  carCheckIn: null,
  loading: {
    parkingSpots: false,
    spotTypes: false,
    parkingLot: false,
  },
  selectedUnpaid: null,
  searchUnpaid: null,
};

const parkingSlice = createSlice({
  name: "parking",
  initialState,
  reducers: {
    setParkingLot: (state, action) => {
      state.parkingLot = action.payload;
    },
    setSelectedSpots: (state, action) => {
      let slotId = action.payload;

      if (state.selectedSpots.includes(slotId)) {
        // If selected, remove from the list
        state.selectedSpots = state.selectedSpots.filter((id) => id !== slotId);
      } else {
        // If not selected, add the list
        if (state.selectedSpots.length == 2) {
          state.selectedSpots = [state.selectedSpots[1], slotId];
        } else {
          state.selectedSpots = [...state.selectedSpots, slotId];
        }

      }
    },
    clearSelectedSpots: (state, action) => {
      state.selectedSpots = [];
    },
    setSelectedSpot: (state, action) => {
      state.selectedSpot = action.payload;
    },
    setParkingSpots: (state, action) => {
      state.parkingSpots = action.payload;
    },
    setCarCheckIn: (state, action) => {
      state.carCheckIn = action.payload;
    },
    updateParkingSpots: (state, action) => {
      const { parkingId, carNum, entryId, spaceNumber, localImage } = action.payload;
      state.parkingSpots = state.parkingSpots.map((spot) =>
        spot.spaceNumber === spaceNumber ? { ...spot, carNum, entryId, parkingId, localImage } : spot
      );
    },
    setParkingSpaceView: (state, action) => {
      state.parkingSpaceView = action.payload;
    },
    setSelectedUnpaid: (state, action) => {
      state.selectedUnpaid = action.payload;
    },
    setSearchUnpaid: (state, action) => {
      state.searchUnpaid = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllParkingSpots.pending, (state) => {
        state.loading.parkingSpots = true;
      })
      .addCase(fetchAllParkingSpots.fulfilled, (state, action) => {
        const { parkingName = '', fullSlotList = [] } = action.payload;
        state.parkingName = parkingName;
        state.loading.parkingSpots = false;
        // Compare Fullslotlist with Parkingspots
        const newSpots = fullSlotList || [];
        const currentSpots = state.parkingSpots || [];
        // Only update the changes
        const updatedSpots = newSpots.map((newSpot, index) => {
          const currentSpot = currentSpots[index];
          if (!currentSpot || currentSpot.spaceNumber !== newSpot.spaceNumber) {
            console.log("No new spot found", currentSpot, newSpot);
            return newSpot; // Keep it without a new spot or other Spacenumber
          }
          // Compare important attributes
          if (
            currentSpot.carNum === newSpot.carNum &&
            currentSpot.entryId === newSpot.entryId &&
            currentSpot.areaName === newSpot.areaName &&
            currentSpot.areaTypeName === newSpot.areaTypeName &&
            currentSpot.parkingId === newSpot.parkingId &&
            currentSpot.inTime === newSpot.inTime &&
            currentSpot.outTime === newSpot.outTime &&
            currentSpot.areaTypeId === newSpot.areaTypeId &&
            currentSpot.payStatusCd === newSpot.payStatusCd  &&
            currentSpot.membership === newSpot?.membership &&
            currentSpot.membershipTypeCd === newSpot?.membershipTypeCd
          ) {
            return currentSpot; // Keep the old reference if not changed
          }
          return { ...newSpot }; // Create a new object for the change spot
        });
       

          state.parkingSpots = updatedSpots;
        
      })
      .addCase(fetchAllParkingSpots.rejected, (state) => {
        state.loading.parkingSpots = false;
      })
      .addCase(fetchAllParkingSpotTypes.fulfilled, (state, action) => {
        state.spotTypes = action.payload;
      })
      .addCase(fetchParkingLot.fulfilled, (state, action) => {
        state.parkingLot = action.payload;
      });
  },
});

export const {
  setParkingLot,
  setSelectedSpots,
  clearSelectedSpots,
  setSelectedSpot,
  setParkingSpots,
  setCarCheckIn,
  updateParkingSpots,
  setParkingSpaceView,
  setSelectedUnpaid,
  setSearchUnpaid,
} = parkingSlice.actions;
export default parkingSlice.reducer;
